var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-container"},[(_vm.flowData)?_c('FlowDesign',{attrs:{"flow-data":_vm.flowData,"obuuid":_vm.obuuid}}):_c('el-empty',{staticStyle:{"height":"100%"},attrs:{"description":_vm.emptyString}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }